import { api_configs } from "src/api-services";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getAttendance = createAsyncThunk(
    'attendancelist/getAttendance',
    async (payload) => {

        try {
            // Simulating async operation, returning dummy data after a delay
            const res = await axios({
                method: "GET",
                // url: `${api_configs.employeeAttendanceList}?userId=${payload}`,
                url: `${api_configs.employeeAttendanceList}?userId=${payload.userIDdata}&createdAtDate=${payload.searchBydate}&yearName=${payload.yearName}&monthName=${payload.monthName}`,
                // headers: {
                //     token: window.localStorage.getItem("token")
                // }
            });
            if (res.data.responseCode === 200) {
                return res.data.result;
            }
            // await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulating delay
            // return cardDetails.data; // Return dummy data directly
        } catch (error) {
            throw error; // Let the rejection handle in createSlice catch this
        }
    }
);

// Slice for products
const AttendanceSlice = createSlice({
    name: 'attendancelist',
    initialState: { isLoading: false, attendance: [], error: null },
    extraReducers: (builder) => {
        builder
            .addCase(getAttendance.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAttendance.fulfilled, (state, action) => {
                state.isLoading = false;
                state.attendance = action.payload;
                state.error = null;
            })
            .addCase(getAttendance.rejected, (state, action) => {
                state.isLoading = false;
                state.attendance = [];
                state.error = action.error.message; // Access error message
            });
    },
});



// Selectors to access state from Redux store
export const selectAttendancelist = (state) => state.attendancelist.attendance;

// Exporting reducers
export default AttendanceSlice.reducer;